class PathUtil {
    static pushState(pathname, params) {
        const searchParams = new URLSearchParams();
        for (let key in params) {
            let value = params[key];
            if (value != null && value != undefined && value != '') {
                searchParams.append(key, value);
            }
        }

        if (params == undefined || params == null || params == '') {
            history.pushState(null, null, pathname);
            return pathname;
        } else {
            const path = pathname + '?' + searchParams.toString();
            history.pushState(null, null, path);
            return path;
        }
    }
}

export default PathUtil;
